import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'frame-custom-content',
    template: `
        <ng-content></ng-content>
    `
})

export class FrameCustomContentComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}